import { c as _c } from "react/compiler-runtime";
import { Col, Container, Row } from "react-bootstrap";
import styles from "./About.module.scss";
export default function AboutCopyright() {
  const $ = _c(22);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <Row><Col><h1>Copyright</h1></Col></Row>;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  let t1;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <Row><Col className={`${styles.lastUpdateText} text-right pt-3 pb-3`}>Last Updated: April 23, 2024</Col></Row>;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <Row className="pt-3 pb-3"><Col><p className="font-larger font-bolder">Introduction</p><p>6529.io, a platform of 6529 Collection LLC, respects the intellectual property rights of others and expects its users to do the same. It is 6529.io's policy to respond to clear notices of alleged copyright infringement that comply with the Digital Millennium Copyright Act (DMCA).</p></Col></Row>;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  let t4;
  let t5;
  let t6;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <p className="font-larger font-bolder">Copyright Infringement Notification</p>;
    t4 = <p>If you believe that your copyrighted work has been copied in a way that constitutes copyright infringement and is accessible through the 6529.io service, you may notify 6529 Collection LLC's copyright agent, providing the following information:</p>;
    t5 = <ol><li>A physical or electronic signature of a person authorized to act on behalf of the owner of an exclusive right that is allegedly infringed.</li><li>Identification of the copyrighted work claimed to have been infringed, or, if multiple copyrighted works at a single online site are covered by a single notification, a representative list of such works at that site.</li><li>Identification of the material that is claimed to be infringing or to be the subject of infringing activity and that is to be removed or access to which is to be disabled, and information reasonably sufficient to permit the service provider to locate the material.</li><li>Information reasonably sufficient to permit the service provider to contact the complaining party, such as an address, telephone number, and, if available, an electronic mail address at which the complaining party may be contacted.</li><li>A statement that the complaining party has a good faith belief that use of the material in the manner complained of is not authorized by the copyright owner, its agent, or the law.</li><li>A statement that the information in the notification is accurate, and under penalty of perjury, that the complaining party is authorized to act on behalf of the owner of an exclusive right that is allegedly infringed.</li></ol>;
    t6 = <p>All DMCA notices should be sent to:</p>;
    $[3] = t3;
    $[4] = t4;
    $[5] = t5;
    $[6] = t6;
  } else {
    t3 = $[3];
    t4 = $[4];
    t5 = $[5];
    t6 = $[6];
  }
  let t7;
  if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = <br />;
    $[7] = t7;
  } else {
    t7 = $[7];
  }
  let t8;
  if ($[8] === Symbol.for("react.memo_cache_sentinel")) {
    t8 = <Row className="pt-3 pb-3"><Col>{t3}{t4}{t5}{t6}<p>DMCA Compliance, 6529 Collection LLC, 2810 N Church Street, PMB 76435, Wilmington, DE 19802-4447{t7}Email: <a href="mailto:6529Ops@6529.io">6529Ops@6529.io</a><br />Phone: 302.219.0696</p></Col></Row>;
    $[8] = t8;
  } else {
    t8 = $[8];
  }
  let t10;
  let t11;
  let t12;
  let t9;
  if ($[9] === Symbol.for("react.memo_cache_sentinel")) {
    t9 = <p className="font-larger font-bolder">Counter-Notification</p>;
    t10 = <p>If you believe that your content that was removed (or to which access was disabled) is not infringing, or that you have the authorization from the copyright owner, the copyright owner's agent, or pursuant to the law, to post and use the content in your submission, you may send a counter-notice containing the following information to 6529 Collection's copyright agent:</p>;
    t11 = <ol><li>Your physical or electronic signature.</li><li>Identification of the content that has been removed or to which access has been disabled and the location at which the content appeared before it was removed or access to it was disabled.</li><li>A statement that you have a good faith belief that the content was removed or disabled as a result of mistake or a misidentification of the content.</li><li>Your name, address, telephone number, and email address, a statement that you consent to the jurisdiction of the federal court in [Jurisdiction], and a statement that you will accept service of process from the person who provided notification of the alleged infringement.</li></ol>;
    t12 = <p>All DMCA notices should be sent to:</p>;
    $[9] = t10;
    $[10] = t11;
    $[11] = t12;
    $[12] = t9;
  } else {
    t10 = $[9];
    t11 = $[10];
    t12 = $[11];
    t9 = $[12];
  }
  let t13;
  if ($[13] === Symbol.for("react.memo_cache_sentinel")) {
    t13 = <br />;
    $[13] = t13;
  } else {
    t13 = $[13];
  }
  let t14;
  if ($[14] === Symbol.for("react.memo_cache_sentinel")) {
    t14 = <Row className="pt-3 pb-3"><Col>{t9}{t10}{t11}{t12}<p>DMCA Compliance, 6529 Collection LLC, 2810 N Church Street, PMB 76435, Wilmington, DE 19802-4447{t13}Email: <a href="mailto:6529Ops@6529.io">6529Ops@6529.io</a><br />Phone: 302.219.0696</p><p>If a counter-notice is received by our Copyright Agent, 6529 Collection LLC may send a copy of the counter-notice to the original complaining party informing that person that it may replace the removed content or cease disabling it in 10 business days. Unless the copyright owner files an action seeking a court order against the content provider, member, or user, the removed content may be replaced, or access to it restored, in 10 to 14 business days or more after receipt of the counter-notice, at 6529 Collection LLC's discretion.</p></Col></Row>;
    $[14] = t14;
  } else {
    t14 = $[14];
  }
  let t15;
  if ($[15] === Symbol.for("react.memo_cache_sentinel")) {
    t15 = <Row className="pt-3 pb-3"><Col><p className="font-larger font-bolder">Repeat Infringer Policy</p><p>In accordance with the DMCA and other applicable law, 6529 Collection LLC has adopted a policy of terminating, in appropriate circumstances and at 6529 Collection LLC's sole discretion, users who are deemed to be repeat infringers. 6529 Collection LLC may also at its sole discretion limit access to the 6529.io and/or terminate the accounts of any users who infringe any intellectual property rights of others, whether or not there is any repeat infringement.</p></Col></Row>;
    $[15] = t15;
  } else {
    t15 = $[15];
  }
  let t16;
  if ($[16] === Symbol.for("react.memo_cache_sentinel")) {
    t16 = <Row className="pt-3 pb-3"><Col><p className="font-larger font-bolder">Modifications to the Policy</p><p>6529 Collection LLC reserves the right to modify the terms of this DMCA Policy at any time and for any reason. By continuing to access or use the 6529.io after those revisions become effective, you agree to be bound by the revised policy.</p></Col></Row>;
    $[16] = t16;
  } else {
    t16 = $[16];
  }
  let t17;
  let t18;
  let t19;
  if ($[17] === Symbol.for("react.memo_cache_sentinel")) {
    t17 = <p className="font-larger font-bolder">Contact Information</p>;
    t18 = <p>For any questions regarding this DMCA Policy, please contact our Copyright Agent's as follows:</p>;
    t19 = <p>All DMCA notices should be sent to:</p>;
    $[17] = t17;
    $[18] = t18;
    $[19] = t19;
  } else {
    t17 = $[17];
    t18 = $[18];
    t19 = $[19];
  }
  let t20;
  if ($[20] === Symbol.for("react.memo_cache_sentinel")) {
    t20 = <br />;
    $[20] = t20;
  } else {
    t20 = $[20];
  }
  let t21;
  if ($[21] === Symbol.for("react.memo_cache_sentinel")) {
    t21 = <Container>{t0}{t1}{t2}{t8}{t14}{t15}{t16}<Row className="pt-3 pb-3"><Col>{t17}{t18}{t19}<p>DMCA Compliance, 6529 Collection LLC, 2810 N Church Street, PMB 76435, Wilmington, DE 19802-4447{t20}Email: <a href="mailto:6529Ops@6529.io">6529Ops@6529.io</a><br />Phone: 302.219.0696</p></Col></Row></Container>;
    $[21] = t21;
  } else {
    t21 = $[21];
  }
  return t21;
}